'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/areas/:areaId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/areas/:areaId/enable', method: 'PUT'},
            delete: {url: 'api/areas/:areaId/delete', method: 'PUT'},
            getDefault: {url: 'api/areas/default', method: 'GET'},
            setDefault: {url: 'api/areas/:areaId/default', method: 'PUT'},
            isUniqueName: {url: 'api/areas/unique/name/:name', method: 'GET'}
        });
    }];